import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container as BlockContainer, Features } from '../components/Blocks'
import { Container, Row, Col } from 'reactstrap'
import { getAssetUrl } from '../services/cdn'

const IndexPage = () => (
  <Layout>
    <SEO title="Promo" keywords={[`gatsby`, `application`, `react`]} />
   <BlockContainer>
      <Container>
        <Row>
          <Col md="12">
              <h5 style={{fontSize: "17px", fontWeight: 400}} className="mb-3 mt-3">Take advantage of the latest KoopSiklo promos and get your dream motorcycle at the best deal. Enjoy exclusive discounts, low down payment options, flexible loan terms, and exciting freebies on select models. These offers are available for a limited time only. Visit KoopSiklo today or send us a message to learn more</h5>
          </Col>
        </Row>
        <Row>
          <Col lg="4" sm="6"  style={{width: "200px"}}>
              <Features src="koopsiklo/promo/promo 1.jpg" ></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 2.jpg" ></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 3.jpg" ></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 4.jpg" ></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 5.jpg" ></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 6.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 7.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 8.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 9.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 10.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 11.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 12.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 13.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 14.jpg"></Features>
          </Col>
          <Col lg="4" sm="6">
              <Features src="koopsiklo/promo/promo 15.jpg"></Features>
          </Col>
        </Row>
           {/* <Col lg="12" sm="6">
               <img src={getAssetUrl("koopsiklo/promo/koopsiklo-promo.jpg")} style={{width: "100%"}} />
          </Col> */}
      </Container>
    </BlockContainer>
  </Layout>
)

export default IndexPage
